
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/sections/bootstrap/plugins/core/attachLabelPlugin.scss.css.virtualfile';
        module.exports = {"container":"_container_nifuj_1","name":"_name_nifuj_7"};